import { IdNameModel } from '@abb-procure/data';
import { Pipe, PipeTransform } from '@angular/core';

export type Classifiable = {
  id: string;
  classificationStatus: IdNameModel | null;
};

@Pipe({
  name: 'classification',
})
export class ClassificationPipe implements PipeTransform {
  transform(
    value: Classifiable[] | null,
    status: number | null,
  ): Classifiable[] {
    const numeric = Number(status);
    return (
      value?.filter(
        (item) => (item.classificationStatus?.id ?? null) === numeric,
      ) ?? []
    );
  }
}
